import {
  ProductElementStatus,
  productElementStatusPropsFactory,
  ProductElementStatusPropsFactoryProps,
} from "@/elements-react/product-element-refactor/components/ProductElementStatus";
import { ProductElementBrand } from "@/elements-react/product-element-refactor/components/ProductElementBrand";
import {
  ProductElementStatusStock,
  ProductElementStatusStockFactoryProps,
  productElementStatusStockPropsFactory,
} from "@/elements-react/product-element-refactor/components/ProductElementStatusStock";
import {
  ProductElementPrice,
  ProductElementPriceFactoryProps,
  productElementPricePropsFactory,
} from "@/elements-react/product-element-refactor/components/ProductElementPrice";
import { ProductElementButton, productElementButtonPropsFactory } from "@/elements-react/product-element-refactor/components/ProductElementButton";
import {
  ProductElementImage,
  productElementImagePropsFactory,
  ProductElementImagePropsFactoryProps,
} from "@/elements-react/product-element-refactor/components/ProductElementImage";
import { ProductElementLinkWrapper } from "@/elements-react/product-element-refactor/components/ProductElementLinkWrapper";
import { HasPropertyProps, useProductElement } from "@/elements-react/product-element-refactor/useProductElement";
import { testid } from "@fixparts/testid/index";
import classNames from "classnames";
import styles from "@/elements-react/product-element/product-element.module.scss";
import { useLayoutType } from "@/util-react/layout";
import { ProductElementTitle } from "@/elements-react/product-element-refactor/components/ProductElementTitle";
import { useCallback } from "preact/hooks";
import { googleEvent } from "@/helpers/google-events";
import { Gtag } from "@/services/gtag";

interface ProductElementProps
  extends ProductElementStatusPropsFactoryProps,
    ProductElementImagePropsFactoryProps,
    HasPropertyProps,
    ProductElementStatusStockFactoryProps,
    ProductElementPriceFactoryProps {
  id: string;
  brand: string;
  mpn: string;
  url?: string;
  mode?: "cart" | "details";
  googleEventData:
    | {
        [p: `item_category${string}`]: string | undefined;
        item_name: string;
        item_id: string;
        price: number;
        item_brand: string;
        index: number;
        quantity: string;
      }
    | undefined;
}

export const ProductElementMostBought = (props: ProductElementProps) => {
  const { id, state, originalMpn, isPrimaryType, images, name, type, mpn, brand, price, mode, url, exchanges, googleEventData }: ProductElementProps = props;
  const { defaultLayoutStyleType } = useLayoutType();
  const { hasProperty } = useProductElement(props);
  const statusElementProps = productElementStatusPropsFactory({ state, isPrimaryType, originalMpn, exchanges });
  const imageElementProps = productElementImagePropsFactory({ images, name });
  const statusStockElementProps = productElementStatusStockPropsFactory({ type, hasProperty });
  const priceElementProps = productElementPricePropsFactory({ hasProperty, state, price });
  const buttonElementProps = productElementButtonPropsFactory({ productId: id });
  const { actionClassNames, handleMouseEnter, handleMouseLeave, handleMouseDown, handleMouseUp } = buttonElementProps;

  const containerClass = classNames(styles.container, actionClassNames, styles[defaultLayoutStyleType], "productCardRoot", { [styles.primary]: isPrimaryType });

  const handleOnClick = useCallback(() => {
    googleEvent("product_click", id);
    Gtag.pushEventEcommerce("select_item", { items: [googleEventData] });
  }, [JSON.stringify(googleEventData)]);

  return (
    <ProductElementLinkWrapper href={url!} productId={id} onClick={handleOnClick}>
      <div
        className={containerClass}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        {...testid({ block: "productCard", modifier: mpn })}
      >
        <ProductElementStatus {...statusElementProps} />
        <ProductElementImage {...imageElementProps} />
        <ProductElementTitle mpn={mpn} name={name} />
        <ProductElementBrand brand={brand} />
        <ProductElementStatusStock {...statusStockElementProps} />
        <ProductElementPrice {...priceElementProps} />
        <ProductElementButton {...buttonElementProps} mode={mode} />
      </div>
    </ProductElementLinkWrapper>
  );
};
